<template>
  <svg height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
    <line id="butt_color" data-name="butt color" fill="none" stroke-linecap="round" stroke-linejoin="round" x1="13" x2="9" y1="7" y2="3" />
    <polygon fill="none" points="5.5 14.5 0.5 15.5 1.5 10.5 11.5 0.5 15.5 4.5 5.5 14.5" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>
